import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme, transientOptions } from "shared/lib/styles";
import type { WithStickyStackedHeightProps } from "shared/lib/styles";

import { AdSlot } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { Flag } from "scmp-app/components/common/loading/wheel-icon/styles";
import { SearchInput } from "scmp-app/components/search/search-input";
import {
  FullWidthBackground,
  StyledMagnifier,
} from "scmp-app/components/search/search-input/styles";

export const StyledSearchInput = styled(SearchInput, {
  ...transientOptions,
})<WithStickyStackedHeightProps>`
  ${FullWidthBackground}, input {
    background: #f7f6ef;
  }

  ${StyledMagnifier} path {
    fill: #001246;
  }

  ${theme.breakpoints.up("tablet")} {
    /** Reduce the padding of the plus header bar */
    inset-block-start: ${props => props.$stickyStackedHeight - 20}px;
  }
`;

export const AdContainer = styled.div`
  ${setFullViewportWidthStyles()}
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: block;
  }
`;

export const SearchContainer = styled.div`
  ${setFullViewportWidthStyles()}
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }

  ${Flag} {
    &::before,
    &::after {
      background-color: #f7f6ef;
    }
  }
`;

export const SearchWrapper = styled.div`
  margin-block-end: 60px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    padding-inline: 32px;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 720px;
    margin-inline: auto;
    padding-inline: 0;
  }
`;

export const StyledAdSlot = styled(AdSlot)`
  padding-block: 20px;
`;
